import React from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles from './styles';

const MicrosoftSignInButton = ({ onClick, theme }) => {
    const classes = useStyles({ theme });
    return (
        <Button
            classes={classes}
            onClick={onClick}
            fullWidth
        />
    );
};

MicrosoftSignInButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(['light', 'dark']),
};

MicrosoftSignInButton.defaultProps = {
    theme: 'light',
};

export default MicrosoftSignInButton;
